import React from 'react';

import DataTable from 'components/DataTable/DataTable';
import EmptyState from 'components/EmptyState/EmptyState';
import { headerCells } from 'Insights/Subscriptions/constants';
import CustomerInsightRow from 'Insights/Subscriptions/pages/CustomerInsightRow';

const SubscriptionsTable = ({ subscriptions, isLoading, onSort, updateList, onSelectRow, users }) => (
  <DataTable
    data={subscriptions}
    isLoading={isLoading}
    columns={headerCells}
    headerAdditionalProps={{
      onSort,
    }}
    TableRowComponent={CustomerInsightRow}
    rowAdditionalProps={{ updateList, onSelectRow, users }}
    EmptySearchComponent={() => <EmptyState message='No Subscriptions' />}
  />
);

export default SubscriptionsTable;
